import { render } from "./announcementFour.vue?vue&type=template&id=bcc9317a"
import script from "./announcementFour.vue?vue&type=script&lang=js"
export * from "./announcementFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__